import { get } from 'lodash';

import { isProd } from '@/utils/getApiDomain';

import { apiPath } from './api-config';
import { request } from './request';

export const fetchTips = async (): Promise<{}> => {
  const url = `${apiPath.tip}?env=${isProd ? 'prod' : 'test'}`;
  const res: any = await request(url);
  const payload = get(res, 'data');
  return payload?.list;
};

export const fetchFeedBack = async (): Promise<{}> => {
  const url = `${apiPath.feedback}`;
  const res: any = await request(url);
  const payload = get(res, 'data');
  return payload?.list;
};
